import { Component } from '@angular/core';
import { Store } from '@ngrx/store';
import {
  resetResponseCategoriesAction,
  searchCategoriesAction,
} from '../stores/actions/categories.actions';
import {
  aggregateCategorie,
  responseCategories,
  searchCategories,
} from '../stores/interfaces/categories.interface';
import { selectCategories } from '../stores/selectors/categories.selectors';
import { environment } from 'src/environments/environment';
import { getLink, linkToObject } from '../stores/utils';
import { Router } from '@angular/router';
import { searchProduits } from '../stores/interfaces/produits.interface';
import { Subscription } from 'rxjs';

@Component({
  selector: 'categories',
  templateUrl: './categories.component.html',
  styleUrls: ['./categories.component.scss'],
})
export class CategoriesComponent {
  categories: aggregateCategorie[] = [];
  total: number = 0;
  requete: searchCategories = {};
  icones: string = '';
  widthIcone: string = '18px';
  objSearch: searchProduits = {};
  formatLink = getLink;
  private subscriptions: Subscription[] = [];

  constructor(private readonly store: Store, private readonly router: Router) {
    this.objSearch = linkToObject(this.router.url);
    this.icones = environment.icones;
    this.requete = {
      destination: this.objSearch.destination,
      tag: this.objSearch.tag,
      search: this.objSearch.search,
    };
    this.store.dispatch(searchCategoriesAction(this.requete));
    const selectCategorie = this.store
      .select(selectCategories)
      .subscribe((p: responseCategories) => {
        this.total = p.total;
        this.categories = [...p.categories];
      });
    this.subscriptions.push(selectCategorie);
  }

  formeWebp(image: string) {
    return image ? `${image.split('.')[0]}.webp` : 'default.webp';
  }

  formePng(image: string) {
    return image ? image : 'default.png';
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((sub) => sub.unsubscribe());
    this.store.dispatch(resetResponseCategoriesAction());
  }
}
